// extracted by mini-css-extract-plugin
module.exports = {"SectorRoles":"styles_SectorRoles__2K8hQ","call_to_action":"styles_call_to_action__Njhz6","height":"styles_height__75Xzh"};